import { render, staticRenderFns } from "./ControlFunctionDetailModal.vue?vue&type=template&id=37ca5eb9"
import script from "./ControlFunctionDetailModal.vue?vue&type=script&lang=js"
export * from "./ControlFunctionDetailModal.vue?vue&type=script&lang=js"
import style0 from "./ControlFunctionDetailModal.vue?vue&type=style&index=0&id=37ca5eb9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports